<template lang="html">
  <div class="mb-2">
    <p v-if="label != ''" class="pt-0 mb-0 small">
      {{ label }}
    </p>
    <b-form-input v-model="_value" :placeholder="placeholder" type="number" />
  </div>
</template>

<script>
export default {
  name: "InputNumber",
  props: {
    label: {
      type: String,
      default: () => ""
    },
    value: {
      type: Number,
      default: () => 0
    },
    placeholder: {
      type: String,
      default: () => "Number"
    }
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(newValue) {
        console.log("newValue", newValue);
        newValue = parseInt(newValue, 10);
        if (newValue >= 0) {
          this.$emit("changed", newValue);
        }
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
